import React, {createRef, CSSProperties, useEffect, useState} from 'react';
import './AboutUs.scss';
import WeAre from "./WeAre/WeAre";
import liquidFigure from "./liquid-figure-min-v2.png";
import rightBg from "./right-bg.jpg";
import structuring from "./structuring.svg";
import designing from "./designing.svg"
import stability from "./stability.svg"
import architecture from "./architecture.svg"
import responsibility from "./responsibility.svg"
import {usePageScrolling} from "../../hooks/usePageScrolling";
import InfinityCarouselStaticWidth from "../../helpers/InfinityCarouselStaticWidth/InfinityCarouselStaticWidth";

function AboutUs() {    
    const rootRef = createRef<HTMLDivElement>();
    const scroll = usePageScrolling();
    const [isShow, setIsShow] = useState(false);
    
    useEffect(() => {
        if(!isShow && ((rootRef.current?.getBoundingClientRect().top  || 0) +(window.innerHeight / 2)) < scroll) setIsShow(true);
    }, [scroll, rootRef.current]);
    
    const leftColumnItems = [
        {
            icon: structuring,
            title: 'Structuring \n' +
                   'complex challenges',
            text: 'We help organizations define system direction when requirements are still forming.',
            style: {
                transition: 'all 1s cubic-bezier(0, 0, 1, 1) 500ms',
            } as CSSProperties,
        },{
            icon: designing,
            title: 'Designing systems\n' +
                   'for change',
            text: 'Our solutions are built to adapt to evolving business, technology and scale conditions.',
            style: {
                transition: 'all 1s cubic-bezier(0, 0, 1, 1) 1500ms',
            } as CSSProperties,
        },{
            icon: stability,
            title: 'Stability under\n' +
                   'uncertainty',
            text: 'We design systems that remain stable in dynamic environments and real-world constraints.',
            style: {
                transition: 'all 1s cubic-bezier(0, 0, 1, 1) 2500ms',
            } as CSSProperties,
        }
    ];
    const rightColumnItems = [
        {
            icon: architecture,
            title: 'Architecture precedes\n' +
                   'implementation',
            text: 'Systems are designed before they are built, with clear structure, boundaries and evolution paths.',
            style: {
                transition: 'all 1s cubic-bezier(0, 0, 1, 1) 3500ms',
            } as CSSProperties,
        },{
            icon: responsibility,
            title: 'Responsibility\n' +
                   'beyond delivery',
            text: 'We remain engaged after launch to support performance, reliability and further development.',
            style: {
                transition: 'all 1s cubic-bezier(0, 0, 1, 1) 4500ms',
            } as CSSProperties,
        }
    ];

    return (
        <>
            <img className={'AboutUs-background'} src={rightBg} alt={'animatedImg'} />
            <div ref={rootRef} className="AboutUs modal-bg">

                <div className="content">
                    <img className={'animated-image levitate'} src={liquidFigure} alt={'animatedImg'}/>
                    <div className={'forTitle'}>
                        <div className={'top'}>
                            <div className={'titleKey'}>Engineering Perspective</div>
                            <div className={'title'}>How We Think About Systems</div>
                        </div>
                        <div className={'underTitleText'}>
                            We engineer systems meant to function in real operational environments - not only in
                            specifications.<br/>
                            <br/>
                            Our work begins with architecture clarity and continues through implementation, scaling and
                            long-term system evolution.
                        </div>
                    </div>
                    <div className={'columns'}>
                        {window.innerWidth < 768
                            ? false
                            :
                            <>
                                <div>
                                    {leftColumnItems.map((item) => (
                                        <WeAre key={item.title} isShow={isShow} icon={item.icon} title={item.title}
                                               text={item.text} style={item.style}/>
                                    ))}
                                </div>
                                <div className={'right'}>
                                    {rightColumnItems.map((item) => (
                                        <WeAre key={item.title} isShow={isShow} icon={item.icon} title={item.title}
                                               text={item.text} style={item.style}/>
                                    ))}
                                </div>
                            </>
                        }

                    </div>
                    <div id={'ai-inside-systems'}/>
                </div>
                {window.innerWidth < 768
                    ? <InfinityCarouselStaticWidth itemWidth={window.innerWidth < 450 ? 1500: 1700} itemRender={
                            () => (<>
                                {leftColumnItems.map((item) => (
                                    <WeAre key={item.title} isShow={true} icon={item.icon} title={item.title} text={item.text} style={item.style} />
                                ))}
                                {rightColumnItems.map((item) => (
                                    <WeAre key={item.title} isShow={true} icon={item.icon} title={item.title} text={item.text} style={item.style} />
                                ))}
                            </>)
                        } />
                    : false
                }
            </div>
        </>
    );
}

export default AboutUs;
